/* eslint-disable no-restricted-syntax */
export function convertToResponseObject(questionObj) {
  const answers = [];
  const termAnswers = {};
  const otherTextValues = {};

  // First pass: collect all _other_text values
  for (const [key, value] of Object.entries(questionObj)) {
    const otherTextMatch = key.match(/^question_(\d+)_other_text$/);
    if (otherTextMatch) {
      const questionId = parseInt(otherTextMatch[1]);
      otherTextValues[questionId] = value;
    }
  }

  // Process each entry in the question object
  for (const [key, value] of Object.entries(questionObj)) {
    // Skip _other_text fields as they're already processed
    if (!key.endsWith("_other_text")) {
      // Check if it's a term answer (e.g., "question_12_term_0")
      const termMatch = key.match(/^question_(\d+)_term_(\d+)$/);

      if (termMatch) {
        const questionId = parseInt(termMatch[1]);
        const termIndex = parseInt(termMatch[2]);

        // Initialize array for this question if it doesn't exist
        if (!termAnswers[questionId]) {
          termAnswers[questionId] = [];
        }

        // Store the term answer at the correct index
        termAnswers[questionId][termIndex] = value;
      } else {
        // Regular question answer
        const questionMatch = key.match(/^question_(\d+)$/);

        if (questionMatch) {
          const questionId = parseInt(questionMatch[1]);
          let answerValue = value;

          // If this question has an _other_text value
          if (otherTextValues[questionId]) {
            if (Array.isArray(value)) {
              // Handle array answers containing "other"
              answerValue = value.map(item =>
                item === "other" ? otherTextValues[questionId] : item
              );
            } else if (value === "other") {
              // Handle single "other" answer
              answerValue = otherTextValues[questionId];
            }
          }

          answers.push({
            question_id: questionId,
            answer: answerValue,
          });
        }
      }
    }
  }

  // Add term answers to the answers array
  for (const [questionId, termArray] of Object.entries(termAnswers)) {
    answers.push({
      question_id: parseInt(questionId),
      answer: termArray,
    });
  }

  // Sort answers by question_id
  answers.sort((a, b) => a.question_id - b.question_id);

  return { answers };
}
